import PropTypes from 'prop-types';
import React from 'react';
import ExpandIcon from '../ExpandIcon';

const AccordionDarkHeader = ({ onClick, expanded, headerText }) => (
  <div className="accordion-dark-header" onClick={onClick}>
    <span className="accordion-dark-header__text">{headerText}</span>
    <ExpandIcon expanded={expanded} className="expand-icon--white" />
  </div>
);

AccordionDarkHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired
};

export default AccordionDarkHeader;
